export const Color = {
  White: "#ffffff",
  Black: "#000000",
  Red: "#ff4343",
  CoolBlue: "rgba(0, 80, 255)",
  RedBorderAlert: "#D1031C",
  Link: "#2d8dd9",
  LinkHover: "#2072b3",
  LightLink: "#2d8dd91a",
  MidnightExpress: "#21263a",
  MidnightExpressLight: "#238dd9",
  MediumGray: "#999999",
  BorderGray: "#d9d9d9",
  DarkGray: "#666666",
  LightGray: "#eeeeee",
  BackgroundLight: "#f4f5f9",
  BackgroundDark: "#10111c",
  PrimaryLightMain: "#430099",
  PrimaryLightDark: "#30006d",
  PrimaryLightLight: "#8566c1",
  TextLightSecondary: "#737373",
  TextDisabled: "rgba(16, 17, 28, 0.68)",
  TextPrimary: "rgba(16, 17, 28, 0.87)",
  BackdropFill: "rgba(16, 17, 28, 0.75)",
  BackgroundGradient: "linear-gradient(90deg, #1400FF 0%, #9D32D5 100%)",
  BackgroundGradientLight: "linear-gradient(90deg, #2C19FC 0%, #B238F2 100%)",
} as const;
